<template>
    <div class="d-flex align-items-stretch">
        <parens
            v-if="showParens"
            left />
        <div class="d-flex align-items-center">
            {{ display }}
        </div>
        <parens v-if="showParens" />
    </div>
</template>

<script>
    import base from "./_baseExpression.vue";
    import { isModuleRegistered } from "SharedStores/util";
    import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";
    import { PROJECT_TYPES, PROJECT_NAMESPACE } from "SharedStores/Project/projectStore";

    export default {
        extends: base,
        computed: {
            display() {
                if (!isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                    throw Error("program store not registered");
                }

                const isProjectStoreRegistered = isModuleRegistered(PROJECT_NAMESPACE, this.$store.state);

                let displayText = "Is Attachment or Data Field Reference Empty?";

                if (this.expression.PublicAttachmentDefinitionId) {
                    const attachmentDefinition = this.$store.getters[PROGRAM_TYPES.getters.attachmentDefinitionFromId](
                        this.expression.PublicAttachmentDefinitionId
                    );

                    displayText = `Is {${attachmentDefinition.Name}} Empty`;

                    if (isProjectStoreRegistered) {
                        const attachment = this.$store.getters[PROJECT_TYPES.getters.attachmentFromId](
                            this.expression.PublicAttachmentDefinitionId
                        );

                        displayText += attachment && !attachment.IsHidden ? ": No" : ": Yes";
                    }
                } else if (this.expression.PublicDataFieldDefinitionId) {
                    const datafieldDefinition = this.$store.getters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](
                        this.expression.PublicDataFieldDefinitionId
                    );

                    displayText = `Is {${datafieldDefinition.Name}} Empty`;

                    if (isProjectStoreRegistered) {
                        const datafieldValue = this.$store.getters[PROJECT_TYPES.getters.dataFieldValueFromId](
                            this.expression.PublicDataFieldDefinitionId
                        );

                        displayText +=
                            datafieldValue && datafieldValue !== null && datafieldValue !== "" ? ": No" : ": Yes";
                    }
                }

                return displayText;
            },
            showParens() {
                //Show Parens only if AttachmentDefinition or DataFieldDefinition is not set.
                return (
                    this.expression.PublicAttachmentDefinitionId === null &&
                    this.expression.PublicDataFieldDefinitionId === null
                );
            }
        }
    };
</script>
